export class DetailsBarController {
    constructor($stateParams, $timeout, JFrogEventBus, $filter, ComponentsDao,XRayUtils) {
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.componentsDao = ComponentsDao;
        this.jfrogEventBus = JFrogEventBus;
        this.XrayUtils = XRayUtils;
        this.compId = $stateParams.componentID;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        let removeGenerlaVersionData = JFrogEventBus.register(this.EVENTS.GENERAL_DETAILS_RECIEVED, (data) => {
            if (data) {
                this.buildDetailsBar(data);
            }
        });
        let removeDetailsBarRefresh = JFrogEventBus.register(this.EVENTS.CUSTOM_ISSUE_INJECTED, (data) => {
            //this.buildDetailsBar(data)
            this.$timeout(() => {
                this.refreshDetailsBar();
            }, 500);

        });

        this.$timeout(() => {
            this.$scope.$on('$destroy', () => {
                removeGenerlaVersionData();
                removeDetailsBarRefresh();
            });
        }, 500);
    }

    refreshDetailsBar() {

        this.componentsDao.getGeneral({$suppress_toaster: true}, {
            package_id: this.compId
        }).$promise.then((details) => {
            if (details) {
                this.buildDetailsBar(details);
            }
        });

    }

    buildDetailsBar(details) {

        this.$widgetObject.model.sharedData.compDetails = {};
        details.type = _.capitalize(details.type);
        this.$widgetObject.model.sharedData.compDetails.general_details = details;
        this.details = [];
        _.each(details, (val, key) => {
            let tmpObj = this.buildDataObj(key, val, details);

            if (_.isObject(tmpObj)) {
                this.details.push(tmpObj);
            }
        });
        this.$timeout(() => {
            this.$widgetObject.showSpinner = false;
        });

    }
    buildDataObj(key, val, data) {
        let obj = {};
        switch (key) {
            case "latest_version" : {
                obj.title = _.startCase(key);
                obj.content = val;
                return obj;
            }
            case "top_severity": {
                obj.title = "Status";
                obj.class = this.XrayUtils.convertSeverityStatus(val) + ' status';
                obj.content = val;
                return obj;
            }
            case "updated": {
                obj.title = 'Modified';
                obj.class = 'modified'
                obj.content = this.$filter('date')(val, 'medium');
                return obj;
            }
            case "created": {
                obj.title = _.startCase(key);
                obj.class = 'created';
                obj.content = this.$filter('date')(val, 'medium');
                return obj;
            }
            case "downloads" : {
                obj.title = _.startCase(key);
                obj.class = 'downloads';
                obj.content = this.kFormatter(val);
                return obj;
            }
            case "pkg_type": {
                let icon = val;
                obj.class = val + ' type-info';
	            if (val == 'rubygems' || val == 'gems')
                    icon = 'ruby';
                obj.title = 'Package Type';
                obj.content = val;

	            val = val.toLowerCase();
                if (val === "maven")
                    obj.iconPath = "images/maven.svg";
                if (val === "bower")
                    obj.iconPath = "images/bower.svg";
	            if (val === "gems" || val === "rubygems")
                    obj.iconPath = "images/ruby.svg";
                if (val === "generic")
                    obj.iconPath = "../../assets/images/generic.svg";
                if (val === "rpm")
                    obj.iconPath = "images/rpm.svg";
                if (val === "debian")
                    obj.iconPath = "images/debian.svg";
	            if (val === "composer") {
		            obj.iconPath = "images/composer.svg";
	            }
	            if (val === "npm")
                    obj.iconPath = "images/npm.svg";
                if (val === "pypi")
                    obj.iconPath = "images/pypi.svg";
                if (val === "nuget")
                    obj.iconPath = "images/nuget.svg";
                if (val === "yum")
                    obj.iconPath = "images/yum.svg";
                if (val === "docker")
                    obj.iconPath = "images/docker.svg";
                if (val === "deb")
                    obj.iconPath = "images/debian.svg";
                if (val === "alpine")
                    obj.iconPath = "images/alpine.svg";
                if (val !== 'build') {
                    if (data) {
                        if (data.website) {
                            obj.template = `<a href="${data.website}" target="_blank"><div  ng-class="[detail.class,detail.icon]" class="detail-content icon icon-external-link"><span><img src="${obj.iconPath}"/></span></div></a>`;
                        } else {
                            obj.template = `<div  ng-class="[detail.class,detail.icon]" class="detail-content"><span><img src="${obj.iconPath}"/></span></div>`;
                        }
                    }

                } else {
                    return "";
                }

                return obj;
            }
            case "website": {

                obj.title = 'website';
                obj.isHidden = true;
                obj.content = val;
                obj.template = `<div ng-if="!detail.template" class="detail-title ng-binding ng-scope">Website</div><span><a target="_blank" href="${val}">${val}</a></span>`;
                return obj;
            }
            case "ci_server": {

                obj.title = 'CI Server';
                obj.content = val;
                return obj;
            }
            case "build_url": {
                obj.isHidden = true;
                obj.title = 'website';
                obj.content = val;
                obj.template = `<div ng-if="!detail.template" class="detail-title ng-binding ng-scope">Website</div><span><a target="_blank" href="${val}">${val}</a></span>`;
                return obj;
            }
            case "latest_versions": {

                obj.title = 'Latest Version';
                obj.content = val;
                obj.class = 'latest-version';
                if (val.internal_version && val.public_version)
                    obj.template = `<div ng-if="!detail.template" class="detail-title ng-binding ng-scope">Latest Version</div><div class="versions-container"><div class="version-container"><div class="version-number">${val.internal_version}</div> <div class="version-type">Local</div></div> / <div class="version-container"><div class="version-number">${val.public_version}</div> <div class="version-type">Public</div></div></div>`;
                if (val.internal_version && !val.public_version) {
                    obj.template = `<div ng-if="!detail.template" class="detail-title ng-binding ng-scope">Latest Version</div><span>${val.internal_version} </span><div class="version-type"><span>Local</span></div>`;
                }
                if (!val.internal_version && val.public_version)
                    obj.template = `<div ng-if="!detail.template" class="detail-title ng-binding ng-scope">Latest Version</div><span>${val.public_version} </span><div class="version-type"><span>Public</span></div>`;


                return obj;
            }
            default: {
                return '';
            }
        }

    }


    convertStatus(severity) {
        return this.XrayUtils.convertSeverityStatus(severity)
    }

    kFormatter(num) {

        if (num) {


            let prefix = "";
            let devider = 1;
            let fixedDecimal = 0;
            if (parseInt(num) > 999) {
                prefix = "K"
                devider = 1000;
                if (parseInt(num) >= 1000000) {
                    prefix = "M";
                    devider = 1000000;
                }
                fixedDecimal = 1;
            }

            let total = this.$filter('number')((parseInt(num) / devider).toFixed(fixedDecimal));


            return `${total}${prefix}`;

        }

    }
}




// WEBPACK FOOTER //
// ./modules/xray/componentsPage_widgets/details_bar/details_bar.controller.js